import { render, staticRenderFns } from "./AlarmComment.vue?vue&type=template&id=6a12b220&scoped=true"
import script from "./AlarmComment.vue?vue&type=script&lang=js"
export * from "./AlarmComment.vue?vue&type=script&lang=js"
import style0 from "./AlarmComment.vue?vue&type=style&index=0&id=6a12b220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12b220",
  null
  
)

export default component.exports